import compose from 'lodash/flowRight';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import { colors } from '../../themes/colors';
import MHButton from '../MHButton';

const styles = () =>
  createStyles({
    cardBackground: {
      display: 'flex',
      flexDirection: 'column',
      width: '573px',
      height: '220px',
    },
    titleText: {
      fontSize: '28px',
      fontWeight: 900,
      marginTop: '50px',
      textAlign: 'center',
    },
    subTitleText: {
      fontSize: '14px',
      fontWeight: 500,
      textAlign: 'center',
      margin: '10px auto 18px',
    },
    memberButton: {
      backgroundColor: colors.blue6,
      boxShadow: '0 8px 12px 0 rgba(183, 186, 190, 0.5)',
    },
    buttonParent: {
      height: '40px',
      margin: '0 auto 10px',
      textAlign: 'center',
      width: '238px',
    },
    clostButton: {
      width: '10px',
      height: '10px',
      objectFit: 'contain',
      position: 'absolute',
      right: '14px',
      top: '14px',
    },
  });

type Props = WithStyles<typeof styles> & {
  onRedirectToUserProfile: () => void;
  onClose: () => void;
};

const ReportVisitConfirmation: React.FC<Props> = ({
  classes,
  onRedirectToUserProfile,
  onClose,
}) => {
  return (
    <Dialog open aria-labelledby="form-dialog-title" maxWidth="md">
      <IconButton className={classes.clostButton} aria-label="Close" onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <DialogContent className={classes.cardBackground}>
        <Typography className={classes.titleText}>
          Your visit details have been submitted
        </Typography>
        <Typography className={classes.subTitleText}>
          Don't forget to send a summary, resources and write a note!
        </Typography>
        <div className={classes.buttonParent}>
          <MHButton
            className={classes.memberButton}
            children="Go to Member Profile"
            onClick={onRedirectToUserProfile}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default compose(withStyles(styles))(ReportVisitConfirmation);
